import type { PartialTheme } from '@repo/theme';
import { getSiloKeyFromWindowUrl, getThemeFromWindowUrl } from 'platform-specific/url';
import { getDeploymentConfig } from 'util/util';

import { zdfThemeNames, zdfThemes } from './zdf/zdf-themes';

const themeNames = [...zdfThemeNames];
type ThemeName = (typeof themeNames)[number];

const themes: Record<ThemeName, PartialTheme> = {
    ...zdfThemes,
};

function getThemeKey(): ThemeName | null {
    const deploymentConfig = getDeploymentConfig();
    const siloKeyUrl = getSiloKeyFromWindowUrl();
    const siloConfig = siloKeyUrl ? deploymentConfig?.siloConfig?.[siloKeyUrl] : undefined;
    const siloThemeKey = siloConfig?.themeKey;
    const urlParamThemeKey = getThemeFromWindowUrl();
    const retrievedThemeKey = urlParamThemeKey ?? siloThemeKey ?? '';
    // Make sure that the provided theme exists
    return themeNames.includes(retrievedThemeKey as ThemeName) ? (retrievedThemeKey as ThemeName) : null;
}

/** Returns the theme selected by the URL or silo config, or null if none. */
export function getTheme(): PartialTheme | null {
    const currentThemeKey = getThemeKey();
    return currentThemeKey ? themes[currentThemeKey] : null;
}
